import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { ITaxInvoiceJournalTransactionRecordDto } from "../../../dtos/transactions/ITaxInvoiceJournalTransactionRecordDto";
import { IDistributionOfLandedCostTransactionRecordDto } from "../../../dtos/transactions/IDistributionOfLandedCostTransactionRecordDto";

interface IProps {
  items: IDistributionOfLandedCostTransactionRecordDto[];
}

export const DistributionOfLandedCostTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="movementType" dataType={"number"} caption="Movement Type" />
          <Column width={150} dataField="recorderType" dataType={"number"} caption="Recorder Type" />
          <Column width={150} dataField="companyId" dataType={"string"} caption="Company Id" />
          <Column width={150} dataField="productId" dataType={"string"} caption="Product Id" />
          <Column width={150} dataField="vendorInvoiceId" dataType={"string"} caption="Vendor Invoice Id" />
          <Column width={150} dataField="expanseAmount" dataType={"number"} caption="Expanse Amount" />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
